import React from 'react'
import { Link } from 'react-router-dom'

import { NavBarEntry } from '@app/NavBar'

import { getOverviewPath } from './paths'

export function useNavbarEntries(): NavBarEntry[] {
  return [
    {
      iconName: 'play',
      title: 'Überblick',
      EntryWrapper: ({ children }) => <Link to={getOverviewPath()}>{children}</Link>,
      active: /^\/ueberblick/
    }
  ]
}
